<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      // RWD
      responsive: true,
      maintainAspectRatio: false,
      // 尺度、比例
      scales: {
        // y軸
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              fontSize: 20,
              fontColor: 'green'
            }
          }
        ]
      },
      legend: {
         position: 'right',
         align: 'start',
         labels: {
            fontColor: 'black',
            fontSize: 16,
            fontFamily: 'Microsoft YaHei',
            padding: 30,
          }
      },
      // 動畫效果
      animation: {
        // 持續時間
        duration: 1000,
        // 完成後執行
        // onComplete: function() {
        //   alert('hi')
        // }
      },
    }
  }),
  // 隨資料重複渲染畫面
  mounted() {
    this.chartRender()
  },
  methods: {
    chartRender() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Chart.vue